export function LCHeadCompose(page, rowL, ll, dataUrl) {
    var doc = ll;
    var _y = rowL;
    // var _space = page.spacingunit;

    var imageX = 210;

    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop, 55, 25);
    // _y += _space * 3;

    return _y;
}

export function LCBodyCompose(page, rowL, ll, data, dataUrl) {
    var doc = ll;
    var _y = rowL;
    var _space = page.spacingunit;
    const margin = 10;
    var newPage = false;

    doc.setFont("times", "bold");
    doc.text('OCEAN TRANSPORT GROUP OF COMPANIES INC.', 150, _y, null, null, 'center');
    doc.setFont("times", "normal");

    _y += _space;
    doc.text('LOADING CONFIRMATION', 150, _y, null, null, 'center');
    _y += _space;

    //headers
    doc.text('Voyage Sequence: ' + data.voyage, 150, _y, null, null, 'center');
    _y += _space;

    doc.text('Vessel: ' + data.vessel, 150, _y, null, null, 'center');
    _y += _space;

    let current_datetime = new Date(data.etd)
    let formatted_date = (current_datetime.getMonth() + 1) + "/" + current_datetime.getDate() + "/" + current_datetime.getFullYear();
    doc.text(margin, _y, `ETD: ${formatted_date}`);

    doc.text(215, _y, 'Transaction Ref: ' + data.transactionRef);
    _y += _space * 1.5;

    //end of headers

    doc.setFont("times", "bold");
    doc.text(`No.`, margin, _y);
    doc.text(`Customer`, margin * 2, _y);
    doc.text(`Details`, margin * 10, _y);
    doc.setFont("times", "normal");
    doc.line(margin, _y + 1, 270, _y + 1);
    _y += _space;

    //details
    // eslint-disable-next-line
    data.myDetails.map((detail, i) => {
        doc.text(margin, _y, (i + 1).toString());

        var splitMargin = (margin * 10) - (margin * 2);

        var splitShipper = doc.splitTextToSize(data.shipper ? 'Shipper: ' + data.shipper : '', splitMargin);
        var splitShipperEmail = doc.splitTextToSize(data.shipperEmail ? 'Email: ' + data.shipperEmail : '', splitMargin);
        var splitConsignee = doc.splitTextToSize(detail.consignee ? 'Consignee: ' + detail.consignee : '', splitMargin);
        var splitConsigneeEmail = doc.splitTextToSize(detail.consigneeEmail ? 'Email: ' + detail.consigneeEmail : '', splitMargin);

        // Shipper
        doc.text(margin * 2, _y, splitShipper);
        var C_y = 0;
        if (splitShipper.length > 1) {
            C_y = (_y + (_space * (splitShipper.length)));
        }
        else {
            C_y = _y + _space;
        }
        // Shipper Email
        doc.text(margin * 2, C_y, splitShipperEmail);
        if (splitShipperEmail.length > 1) {
            C_y += (_space * splitShipperEmail.length);
        }
        else {
            C_y += _space;
        }

        // Consignee
        doc.text(margin * 2, C_y, splitConsignee);
        if (splitConsignee.length > 1) {
            C_y += ((_space * splitConsignee.length) - 1);
        }
        else {
            C_y += _space;
        }

        // Consignee Email
        doc.text(margin * 2, C_y, splitConsigneeEmail);

        // Details
        doc.text(margin * 10, _y, 'Cargo Description: ' + detail.goods);
        _y += _space;

        doc.text(margin * 10, _y, 'Booking Ref: ' + detail.bookingRef);
        doc.text(margin * 15, _y, 'Waybill: ' + detail.wayBillRef);
        doc.text(margin * 20, _y, 'Seal #: ' + detail.sealNum);
        _y += _space;

        doc.text(margin * 10, _y, 'Van #: ' + detail.cargo);
        doc.text(margin * 15, _y, 'Service Mode: ' + detail.modeOfDelivery);
        doc.text(margin * 20, _y, 'Mode of Payment: ' + detail.modeOfPayment);
        _y += _space;

        doc.text(margin * 10, _y, 'Destination: ' + detail.destination);
        doc.text(margin * 15, _y, 'ETA: ' + detail.eta);
        doc.text(margin * 20, _y, 'Remarks: ' + detail.remarks);

        // Line For Next Number
        if (splitConsigneeEmail.length > 1) {
            _y += (_space * splitConsigneeEmail.length);
        } else {
            _y += _space;
        }
        doc.line(margin, _y + 1, 270, _y + 1);
        _y += _space;

        if (_y >= 195) {
            _y = page.margin.top;
            doc.addPage(page.layoutL, page.papersize.unit, page.papersize.format);
            var imageX = 210;
            newPage = true;
            if (newPage) {
                doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop, 55, 25);

                doc.setFont("times", "bold");
                doc.text('OCEAN TRANSPORT GROUP OF COMPANIES INC.', 150, _y, null, null, 'center');
                doc.setFont("times", "normal");

                _y += _space;
                doc.text('LOADING CONFIRMATION', 150, _y, null, null, 'center');
                _y += _space;

                //headers
                doc.text('Voyage Sequence: ' + data.voyage, 150, _y, null, null, 'center');
                _y += _space;

                doc.text('Vessel: ' + data.vessel, 150, _y, null, null, 'center');
                _y += _space;

                doc.text(margin, _y, `ETD: ${formatted_date}`);

                doc.text(215, _y, 'Transaction Ref: ' + data.transactionRef);
                _y += _space * 1.5;

                //end of headers

                doc.setFont("times", "bold");
                doc.text(`No.`, margin, _y);
                doc.text(`Customer`, margin * 2, _y);
                doc.text(`Details`, margin * 10, _y);
                doc.setFont("times", "normal");
                doc.line(margin, _y + 1, 270, _y + 1);
                _y += _space;
            }
        }
        else {
            newPage = false;
        }
    });
    //end of details
}